<template>
  <div class="wrapper">
    <van-form @submit="onSubmit">
      <div class="header-form">
        <div class="header-form-title">{{ title }}</div>
        <!-- <div style="height: 80px"></div>
        <div class="header-form-user">
          <img src="@/assets/index/messges.png" alt="" />
          <span class="name">{{ card.patientname }}</span>
          <span>性别：{{ card.sex }}</span>
          <span>年龄: {{ age }}</span>
        </div> -->
      </div>
      <div class="headerWrap">
        <div class="header-item">
          <div class="header-radioTitle">
            <span style="color: red">*</span> 1、您的姓名?
          </div>
          <div class="header-input">
            <div>
              <input :name="name" v-model="name" placeholder="请输入您的姓名" />
            </div>
          </div>
        </div>
        <div class="header-item">
          <div class="header-radioTitle">
            <span style="color: red">*</span> 2、手机号?
          </div>
          <div class="header-input">
            <div>
              <input :name="phone" v-model="phone" placeholder="请输入您的手机号码" @blur="judge"/>
              <span v-if="showErr" style="color: red;margin-left: 6px;">请输入正确的手机号码！</span>
            </div>
          </div>
        </div>
        <div class="header-item">
          <div class="header-radioTitle">
            3、住院号?
          </div>
          <div class="header-input">
            <div>
              <input :name="zyId" v-model="zyId" placeholder="请输入您的住院号" />
            </div>
          </div>
        </div>
        <div class="header-item">
          <div class="header-radioTitle">
            <span style="color: red">*</span> 4、您的就诊院区?
          </div>
          <div class="header-selece">
            <div v-for="item in hospitalList" :key="item.hspCode">
              <!-- 单选 -->
              <van-radio-group
                v-model="hspCode"
                direction="horizontal"
              >
                <van-radio :name="item.hspCode">{{ item.hspName }}</van-radio>
              </van-radio-group>
            </div>
          </div>
        </div>
        <div class="header-item">
          <div class="header-radioTitle">
            <span style="color: red">*</span> 5、您的就诊科室?
          </div>
          <div class="header-input">
            <el-select v-model="deptCode" filterable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.deptCode"
              :label="item.deptName"
              :value="item.deptCode">
            </el-option>
          </el-select>
          </div>
        </div>
        <div
          class="header-item"
          v-for="(item, index) in pquestionList"
          :key="index"
        >
          <div class="header-radioTitle">
            <span v-if="item.type != 1" style="color: red">*</span>
            <span>{{ index + 6 }}、{{ item.question }}</span>
            <span v-if="item.type == 2" style="color: #999">【多选题】</span>
          </div>
          <div class="header-selece">
            <div v-for="i in item.qanswersVoList" :key="i.aid">
              <!-- 单选 -->
              <van-radio-group
                v-model="item.answer"
                direction="horizontal"
                v-if="item.type == 0"
              >
                <van-radio :name="i.answer">{{ i.answer }}</van-radio>
              </van-radio-group>
              <!-- 多选 -->
              <van-checkbox-group v-model="item.answer" v-if="item.type == 2">
                <van-checkbox :name="i.answer" shape="square">{{
                  i.answer
                }}</van-checkbox>
              </van-checkbox-group>
            </div>
          </div>
          <div class="header-input">
            <div v-for="i in item.qanswersVoList" :key="i.aid">
              <input
                v-if="item.type == 8"
                :name="i.answer"
                shape="square"
                v-model="item.answer"
              />
              <textarea
                rows="8"
                cols="20"
                v-if="item.type == 1"
                v-model="item.answer"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="foot-botton">
          <van-button
            round
            block
            :disabled="pquestionList.length == 0"
            type="info"
            native-type="submit"
            >提 交</van-button
          >
        </div>
      </div>
    </van-form>
  </div>
</template>

<script>
import {
  getSatisfactionsSurvey,
  fillSatisfactionsSurvey,
  selectBHosptialinfo,
  selectBDeptinfo
} from "@/request/api.js";
import { GetRequest } from "@/tool/parameter.js";
export default {
  data() {
    return {
      title: "",
      card: {},
      age: "",
      pquestionList: [],
      questionnaireId: "",
      name: "",
      phone: "",
      zyId: "",
      showErr: false,
      hospitalList: [],
      hspCode: "",
      deptCode: "",
      options: []
    };
  },
  created() {
    this.card = JSON.parse(sessionStorage.getItem("card"));
    this.age = new Date().getFullYear() - this.card.idcardno.substring(6, 10);
    this.gethospital();
    this.getdept();
    this.getList();
  },
  methods: {
    // 获取院区
    async gethospital(){
      let res = await selectBHosptialinfo();
      this.hospitalList = res.data.obj
    },
    // 获取科室
    async getdept(){
      let map = {
        queryRequest: {
          pageNum: 1,
          pageSize: 999,
          sortField: "",
          sortOrder: ""
        }
      }
      let res = await selectBDeptinfo(map)
      this.options = res.data.obj.records;
    },
    // 获取问卷数据
    async getList() {
      let res = await getSatisfactionsSurvey(GetRequest("questionnaireId"));
      this.title = res.data.obj.questionnaireName;
      this.pquestionList = res.data.obj.qquestionsVos;
      this.questionnaireId = res.data.obj.questionnaireId;
      this.pquestionList.sort((a, b) => {
        return a.type - b.type;
      });
    },
    // 校验身份证是否正确
    judge(){
      this.showErr = !/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.phone)
    },
    // 提交问卷
    async onSubmit() {
      let list = this.pquestionList;
      console.log(this.name,this.phone,this.hspCode,this.deptCode)
      let list2 = list.filter(el => { return el.type != 1 })
      let flag = list2.some(els => els.answer == "" || els.answer == null);
      let flag2 = true;
      if((this.name == "" || this.name == null) || (this.phone == "" || this.phone == null) || (this.hspCode == "" || this.hspCode == null) || (this.deptCode == "" || this.deptCode == null)){
        flag2 = true
      } else {
        flag2 = false
      }
      if(this.showErr){
        this.Toast.fail("身份证号码错误");
        return
      }
      console.log(flag,flag2)
      if (!(flag || flag2)) {
        let map = [];
        list.forEach(item => {
          if(item.answer == null) item.answer = ""
          map.push({
            deptCode: this.deptCode,
            hspCode: this.hspCode,
            phone: this.phone,
            inpatNo: this.zyId,
            patname: this.name,
            answer: Array.isArray(item.answer)?item.answer.join(","):item.answer,
            qid: item.qid,
            questionnaireId: this.questionnaireId,
            type: item.type
          });
        });
        this.Toast.loading({
          duration: 1500, // 持续展示 toast
          forbidClick: true,
          message: "问卷生成中"
        });
        setTimeout(() => {
          this.$router.go(-1);
        }, 1500);
        let res = await fillSatisfactionsSurvey(map);
      } else {
        this.Toast.fail("请填写完问卷");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .foot-botton {
    margin: 15px 10px;
  }
  .foot-botton .van-button--info {
    background-color: #589ccb;
    border: 1px solid #589ccb;
  }
  .header-form-title {
    font-size: 22px;
    color: #333;
    text-indent: 1em;
    line-height: 80px;
    height: 80px;
    color: #fff;
    font-family: Source Han Sans CN;
    font-weight: bold;
    background-color: #1989fa;
    background-image: url("../../../assets/index/top.png");
    background-size: 100% 100%;
    border: 1px solid #1989fa;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.27);
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 999;
  }
  .wrapper-title {
    font-size: 14px;
  }
  .header-form-tip {
    font-size: 12px;
    color: #707070;
    line-height: 18px;
    padding: 10px;
    margin: 0 15px;
    border-radius: 8px;
    background: #fff;
    margin-top: 15px;
  }
  .header-form-border {
    border-radius: 8px;
    padding: 10px;
  }
  .header-form-tip p {
    color: #589ccb;
    margin: 0;
    padding-bottom: 5px;
    font-size: 16px;
    font-weight: bold;
  }
  .header-item .header-radioTitle {
    font-size: 14px;
    color: #333;
    padding: 8px;
    font-weight: bold;
  }
  .headerWrap {
    background-color: #fff;
    border-radius: 8px;
    margin: 90px 15px 8px;
    padding: 5px 10px;
  }
  /deep/ .header-input {
    padding: 0 10px;
    .el-select {
      width: 100%;
      .el-input__inner {
        height: 30px;
      }
      .el-input__icon {
        line-height: 0px;
      }
    }
  }
  .header-input input {
    border: 1px solid #ccc;
    height: 30px;
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
    font-size: 13px;
    color: #666;
    text-indent: 5px;
  }
  .header-input textarea {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;
    font-size: 13px;
    color: #666;
    text-indent: 5px;
  }
  .header-selece {
    display: flex;
    text-align: center;
    flex-wrap: wrap;
    justify-content: space-between;
    letter-spacing: 1px;
  }
  .header-selece > div {
    min-width: 33.3%;
  }
  .header-form-user {
    text-align: center;
    height: 50px;
    line-height: 50px;
    background-color: #68bceb;
  }
  .header-form-user img {
    display: inline-block;
    vertical-align: middle;
    height: 25px;
  }
  .header-form-user > span {
    display: inline-block;
    padding: 0 15px;
    vertical-align: middle;
    color: #fff;
    font-size: 13px;
  }
  .header-form-user .name {
    font-size: 20px;
  }
  .van-radio,
  .van-checkbox {
    padding: 10px;
    font-size: 13px;
  }
  .header-collapse {
    /* border: 1px solid red; */
    background-color: #fff;
    font-size: 12px;
    color: #707070;
    line-height: 18px;
    padding: 10px 0;
    margin: 10px 15px;
    border-radius: 8px;
  }
  .header-collapse-title {
    font-weight: bold;
    line-height: 10px;
    color: #589ccb;
    font-size: 16px;
    padding: 5px 15px 10px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/questionnaire/questionnaireList.vue